import { z } from 'zod'

const ItemReserveSchema = z.object({
  tagId: z.string().uuid().optional(),
  unit: z.string(),
  qty: z.number(),
  location: z.string(),
  itemLot: z.object({
    itemId: z.number(),
    partyId: z.number().nullable(),
    isClaimItem: z.boolean(),
    lotNo: z.string(),
    lotDate: z.coerce.date(),
    mold: z.string(),
    unit: z.string(),
  }),
})
export type Inv1210ItemReserveModel = z.input<typeof ItemReserveSchema>

const ItemRequestSchema = z.object({
  id: z.number(),
  seq: z.number().optional(),
  itemId: z.number(),
  lotNo: z.string().nullable(),
  mold: z.string().nullable(),
  unit: z.string(),
  qty: z.number(),
  isClaimItem: z.boolean().nullable(),
  isConfirmPicked: z.boolean().nullable(),
  isPickMatchReserved: z.boolean().nullable(),
  reserveItems: z.array(ItemReserveSchema),
  manualItems: z.array(ItemReserveSchema),
})

export type Inv1210ItemModel = z.input<typeof ItemRequestSchema>

export const Inv1210GetResultSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  partyId: z.number().nullable(),
  refNo: z.string(),
  refDate: z.coerce.date().nullable(),
  dueDate: z.coerce.date().nullable(),
  remark: z.string().nullish(),
  requestItems: z.array(ItemRequestSchema),
  status: z.number(),
  isFulfilled: z.boolean().nullish(),
  confirmed: z.boolean().optional(),
  confirmInfo: z
    .object({
      date: z.coerce.date().nullable(),
      byName: z.string().optional(),
      remark: z.string().optional(),
    })
    .optional(),
})

export type Inv1210GetResultModel = z.input<typeof Inv1210GetResultSchema>
